export const EquipmentLinks = {
    '11001': {
        default: {
            inApp: '/equipements/{{cid}}/11001/internet',
        },
    },
    '21001': {
        default: {
            inApp: '/equipements/{{cid}}/21001/decodeur-tv',
        },
    },
    '21002': {
        default: {
            inApp: '/equipements/{{cid}}/21002/decodeur-tv',
        },
    },
    '22001': {
        default: {
            inApp: '/equipements/{{cid}}/22001/cle-tv',
        },
    },
    '33a001': {
        '33a': {
            inApp: '/equipements/{{cid}}/47001/femtocell',
        },
    },
    '31001': {
        default: {
            inApp: '/equipements/{{cid}}/31001/mobile',
        },
    },
    '33001': {
        default: {
            web: {
                nec: '/?page=equipement-homelive&idContrat={{cid}}&idUsage=33001',
            },
            webapp: {
                nec: '/m/?page=usage-shs&idContrat={{cid}}&idUsage=33001',
            },
        },
    },
    '41001': {
        default: {
            inApp: '/equipements/{{cid}}/41001/tablette-cle',
        },
    },
    '43001': {
        default: {
            inApp: '/equipements/{{cid}}/43001/multisim',
        },
    },
    '44001': {
        '44': {
            inApp: '/equipements/{{cid}}/44001/multisim',
        },
        '44a': {
            web: {
                nec: '/?page=equipement-multisim&idContrat={{cid}}&idUsage=44001',
            },
            webapp: {
                nec: '/m/?page=usage-multisim&idContrat={{cid}}&idUsage=44001',
            },
        },
    },
    '45001': {
        default: {
            inApp: '/equipements/{{cid}}/45001/airbox',
        },
    },
    '46001': {
        default: {
            inApp: '/equipements/{{cid}}/46001/flybox',
        },
    },
    '47001': {
        default: {
            inApp: '/equipements/{{cid}}/47001/femtocell',
        },
    },
    '51001': {
        idSuiviConso: {
            inApp: '/equipements/{{cid}}/51001/tel-fixe',
        },
        default: {
            inApp: '/equipements/{{cid}}/51001/tel-fixe',
        },
    },
    '52001': {
        idSuiviConso: {
            inApp: '/equipements/{{cid}}/52001/tel-fixe',
        },
        default: {
            inApp: '/equipements/{{cid}}/52001/tel-fixe',
        },
    },
    '53001': {
        idSuiviConso: {
            inApp: '/equipements/{{cid}}/53001/tel-fixe',
        },
        default: {
            inApp: '/equipements/{{cid}}/53001/tel-fixe',
        },
    },
    '54001': {
        default: {
            inApp: '/equipements/{{cid}}/54001/tel-voip',
        },
    },
    '55001': {
        default: {
            inApp: '/equipements/{{cid}}/55001/tel-voip',
        },
    },
    '56001': {
        idSuiviConso: {
            inApp: '/conso/{{cid}}/equipement/',
        },
        default: {
            inApp: '/conso/{{cid}}/equipement/equipement-principal',
        },
    },
};
